import { asis } from '@proc7ts/primitives';
import { RequestCapability } from '../../core/request-capability.js';
import { requestExtension } from '../../core/request-modification.js';
import { readAll } from '../../impl/read-all.js';
import { HttpError } from '../http-error.js';
/**
 * @internal
 */
const JSON_MIMES = {
    'text/plain': 1,
    'application/json': 1,
    'text/json': 1,
};
/**
 * @internal
 */
class JsonParsingCapability extends RequestCapability {
    #transform;
    constructor(transform) {
        super();
        this.#transform = transform;
    }
    for(handler) {
        return async (context) => {
            const { request, next } = context;
            const { 'content-type': contentType = 'text/plain' } = request.headers;
            if (!JSON_MIMES[contentType]) {
                return Promise.reject(new HttpError(415, { details: `application/json request expected` }));
            }
            let json;
            const text = await readAll(request);
            try {
                json = JSON.parse(text);
            }
            catch (cause) {
                return Promise.reject(new HttpError(400, { details: 'Malformed JSON', cause }));
            }
            return next(handler, requestExtension({
                requestBody: await this.#transform(json, context),
            }));
        };
    }
    withBody(transformer) {
        return new JsonParsingCapability(transformer);
    }
}
/**
 * JSON request body parsing capability.
 *
 * Parses request body as JSON.
 */
export const JsonParsing = new JsonParsingCapability(asis);
//# sourceMappingURL=json-parsing.capability.js.map